import Container from '../Container/Container';
import Button from '../Button/Button';
import './OperationCompleted.css';

interface OperationCompletedProps {
  title: string;
  confirmLabel: string;
  onConfirm: () => void;
}

// Full-page completion screen (white-box, mirrors ConnectionError styling)
const OperationCompleted = ({
  title,
  confirmLabel,
  onConfirm,
}: OperationCompletedProps) => (
  <Container className="operation-completed">
    <div className="white-box">
      <h1>{title}</h1>
      <Button onClick={onConfirm}>{confirmLabel}</Button>
    </div>
  </Container>
);

export default OperationCompleted;
